module.exports = __webpack_public_path__ + "media/bootstrap-icons/info-circle-9ddf6077.svg";